module.exports = __webpack_public_path__ + "img/icon_site_settings_selected.6e49510e.svg";